import dayjs from "dayjs";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import InputData from "../Model/InputData";
import SalarySimMappedData from "../Model/SalarySimInputPostData";
import SalarySimInputPostData from "../Model/SalarySimInputPostData";



const MapService = (salaryparamin:InputData, isSimpleSimu : boolean )=>{

    const MappedData=new SalarySimMappedData();

    MappedData.mode_simul=isSimpleSimu?"IBRUNET":"IBRUNETPLUS";
    MappedData.agent = salaryparamin.agent;

    MappedData.mois_periode_paie=salaryparamin.Period;

    MappedData.cd_etat_civil=salaryparamin.MaritalStatus;
    
    MappedData.No_Unite_Locale=parseInt(salaryparamin.EstablishmentUnit);
    MappedData.cd_region_domicile=0;
    
    MappedData.Cd_Competence = salaryparamin.HomeRegionCode;

   MappedData.Date_Naissance=dayjs(salaryparamin.BirthDate);

    if(salaryparamin.Disabled)
    {
        MappedData.cd_handicape=1;
    }else{
        MappedData.cd_handicape=0;
    }     
    
    MappedData.cd_conjoint=salaryparamin.Spouse;
        
    if(salaryparamin.DisabledSpouse)
    {
        MappedData.cd_conjoint_handicape=1;
        
    }else{
        MappedData.cd_conjoint_handicape=0;
       
    }

    if (salaryparamin.Dependant)
    {
        MappedData.nb_enfants_charge=salaryparamin.DependantChildren;
        MappedData.nb_enfants_handicapes_charge=salaryparamin.DisabledDependantChildren;

        MappedData.nb_autres_personnes_charge=salaryparamin.OthersDependant;
        MappedData.nb_autres_personnes_handicapees_charge=salaryparamin.OthersDisabledDependant;

        MappedData.nb_autres_personnes_plus65_charge=salaryparamin.More65TransitionalMeasureDependant;
        MappedData.nb_autres_personnes_plus65_handicapees_charge=salaryparamin.More65TransitionalMeasureDisabledDependant;
       
        MappedData.nb_plus65_situation_dependance=salaryparamin.More65DependanceSituationDependant;
    }
   
    if(salaryparamin.NetToBrut)
    {
        MappedData.net=salaryparamin.MonthlyAmount;
        MappedData.brut=0;
    }else{
        MappedData.net=0
        MappedData.brut=salaryparamin.MonthlyAmount;
    }
  
    MappedData.cd_type_contrat=salaryparamin.ContractType;

    //Assurance groupe
    MappedData.assurance_groupe=salaryparamin.CollectiveInsuranceAmount;
    MappedData.assurance_groupe_empl=salaryparamin.CollectiveInsuranceEmployeurIntervAmount;

    //Regime horaire par defaut, calcul simple
    if(isSimpleSimu)
    {
        let tabHoraire=[456,456,456,456,456,0,0];
        MappedData.regime_horaire=tabHoraire;
        MappedData.regime_horaire_emp=tabHoraire;
        
        MappedData.cd_soumis_precompte=1;
        MappedData.Scenario_1er_Engage = 0
    }
   
    //calcul avancé
    if(!isSimpleSimu)
    {
        MappedData.nom = salaryparamin.UserName;
        MappedData.Scenario_1er_Engage = salaryparamin.HiringType;

        //screen 2
        salaryparamin.OnssSubmitted ? MappedData.cd_soumis_onss=1 : MappedData.cd_soumis_onss=0;
        MappedData.commission_paritaire=salaryparamin.JointCommittee;
        MappedData.prefixe_onss=salaryparamin.OnssPrefix;
        MappedData.Activite_Sportive_Secondaire=salaryparamin.SecondaryActivity;

        if(salaryparamin.OnssPrefix.length==1)
        {
            MappedData.prefixe_onss="00" + salaryparamin.OnssPrefix.toString();
        }
        if(salaryparamin.OnssPrefix.length==2)
        {
            MappedData.prefixe_onss="0" + salaryparamin.OnssPrefix.toString();
        }

        if (MappedData.commission_paritaire == "") {
            MappedData.commission_paritaire = "00000000000";
            MappedData.prefixe_onss = "001";
        }
            

        MappedData.cd_effectif_employeur=parseInt(salaryparamin.NumberEmployees);
        MappedData.cd_soumis_precompte=parseInt(salaryparamin.ProfDeductionSubmitted);
    

        if(salaryparamin.PartTime)
        {   
            MappedData.cd_temps_plein=2; 

            //regime horaire=>tableau de 7j en minutes
            let tabHoraire=[parseInt(salaryparamin.MondaySchedule),
            parseInt(salaryparamin.TuesdaySchedule),
            parseInt(salaryparamin.WednesdaySchedule),
            parseInt(salaryparamin.ThursdaySchedule),
            parseInt(salaryparamin.FridaySchedule),
            parseInt(salaryparamin.SaturdaySchedule),
            parseInt(salaryparamin.SundaySchedule)
            ]
            MappedData.regime_horaire=tabHoraire;
         
            //regime horaire reference
            let tabHoraireRef=[parseInt(salaryparamin.MondayScheduleRef),
            parseInt(salaryparamin.TuesdayScheduleRef),
            parseInt(salaryparamin.WednesdayScheduleRef),
            parseInt(salaryparamin.ThursdayScheduleRef),
            parseInt(salaryparamin.FridayScheduleRef),
            parseInt(salaryparamin.SaturdayScheduleRef),
            parseInt(salaryparamin.SundayScheduleRef)
            ]
            MappedData.regime_horaire_emp=tabHoraireRef;

        }else{
            MappedData.cd_temps_plein=1;

            let tabHoraire=[456,456,456,456,456,0,0];
            MappedData.regime_horaire=tabHoraire;
            MappedData.regime_horaire_emp=tabHoraire;
        }
    
      

        //screen 3
        if(salaryparamin.NetToBrut)
        {
            MappedData.net=salaryparamin.MonthlyAmount;
            MappedData.brut=0;
        }else{
            MappedData.net=0
            MappedData.brut=salaryparamin.MonthlyAmount;
        }
   
        MappedData.Montant_Imposable_Pp_Ordinaire=salaryparamin.ProfDeductionAmount;
        MappedData.Montant_Brut_Soumis_Pp=salaryparamin.GrossSubmittedAmount;

        MappedData.avantages_nature=salaryparamin.NetBenefitAmount;       
        MappedData.avantages_nature_voiture=salaryparamin.NetCarBenefitAmount;
        MappedData.Sans_Avantage_Domicile_Travail=!(salaryparamin.HasWorkHomeBenefit);
        MappedData.mt_cot_trav_assurance_groupe=salaryparamin.CollectiveInsuranceAmount;
        MappedData.divers_net_neg=salaryparamin.OtherNegativeAmount;
        MappedData.divers_net_pos=salaryparamin.OtherPositiveAmount;

        MappedData.mt_cot_empl_assurance_groupe=salaryparamin.CollectiveInsuranceEmployeurIntervAmount;
        //MappedData.mt_cot_empl_assurance_groupe=salaryparamin.CollectiveInsuranceAmount;

        MappedData.commissions=salaryparamin.Commissions;

        MappedData.prime_fin_annee=salaryparamin.EndYearBonusAmount;
        MappedData.Prime_Fin_Annee_Forem_Non_Soumise=salaryparamin.EndYearBonusAmountForemNotSubmitted;
        MappedData.Prime_Fin_Annee_Forem_Soumise=salaryparamin.EndYearBonusAmountForemSubmitted;

        MappedData.remuneration_non_periodique=salaryparamin.NonReccurentDirectorAmount;
        MappedData.Droits_Auteur=salaryparamin.MonthlyCopyrightAmount;


        //--------------------------------------------------------------------------------
        // exercice courant
        MappedData.pecule_vacances=salaryparamin.CurrentDoubleBonusAmount; // pécule = double pécule de vacances
        MappedData.complement_pecule_vacances=salaryparamin.CurrentAdditionalBonusAmount;
        
        // exercice précédent
        MappedData.simple_pecule=salaryparamin.PreviousBonusAmount;
        MappedData.double_pecule=salaryparamin.PreviousDoubleBonusAmount;
        MappedData.complement_pecule=salaryparamin.PreviousAdditionalBonusAmount;
      
        // exercice anticipé
        MappedData.simple_pecule_anticipe=salaryparamin.AdvanceBonusAmount;
        MappedData.double_pecule_anticipe=salaryparamin.AdvanceDoubleBonusAmount;
        MappedData.complement_pecule_anticipe=salaryparamin.AdvanceAdditionalBonusAmount;

        //------------------------------------------------------------------------------------------------------


        MappedData.abonnement_social=salaryparamin.PublicTransportationAmount;
        MappedData.frais_deplacement=salaryparamin.PrivateTransportationAmount; 


       MappedData.dt_deb_reduction_onss=new Date("01/01/0001");
       MappedData.Dt_Debut_Contrat=new Date("01/01/0001");
       MappedData.Dt_Fin_Contrat=new Date("01/01/0001");

       

        MappedData.origine="ibrunet";
        
    }     
 
   return MappedData;

}

export const MapServiceInputPostDataToInputData = (MappedData:SalarySimInputPostData) => {
    const salaryparamin=new InputData();

    salaryparamin.Period = MappedData.mois_periode_paie;
    salaryparamin.MaritalStatus = MappedData.cd_etat_civil;
    salaryparamin.EstablishmentUnit = MappedData.No_Unite_Locale.toString();

    salaryparamin.HomeRegionCode = MappedData.Cd_Competence;

    salaryparamin.BirthDate = MappedData.Date_Naissance.toString();
    

    if(MappedData.cd_handicape == 1)
    {
        salaryparamin.Disabled = true;
        
    }else{
        salaryparamin.Disabled = false;
    }    

    salaryparamin.Spouse = MappedData.cd_conjoint;

    if(MappedData.cd_conjoint_handicape == 1){
        salaryparamin.DisabledSpouse = true;
    }else{
        salaryparamin.DisabledSpouse = false;
    }

    // if (salaryparamin.Dependant)
    if(MappedData.nb_enfants_charge > 0 || MappedData.nb_enfants_handicapes_charge > 0 ||
        MappedData.nb_autres_personnes_charge > 0 || MappedData.nb_autres_personnes_handicapees_charge > 0 ||
        MappedData.nb_autres_personnes_plus65_charge > 0 || MappedData.nb_autres_personnes_plus65_handicapees_charge > 0 || 
        MappedData.nb_plus65_situation_dependance > 0){
        salaryparamin.Dependant = true;
    }else{
        salaryparamin.Dependant = false;
    }

    salaryparamin.DependantChildren = MappedData.nb_enfants_charge;
    salaryparamin.DisabledDependantChildren = MappedData.nb_enfants_handicapes_charge;
    salaryparamin.OthersDependant = MappedData.nb_autres_personnes_charge;

    salaryparamin.OthersDisabledDependant = MappedData.nb_autres_personnes_handicapees_charge;
    salaryparamin.More65TransitionalMeasureDependant = MappedData.nb_autres_personnes_plus65_charge;

    salaryparamin.More65TransitionalMeasureDisabledDependant = MappedData.nb_autres_personnes_plus65_handicapees_charge;
    salaryparamin.More65DependanceSituationDependant = MappedData.nb_plus65_situation_dependance;

    if(MappedData.brut == 0){
        salaryparamin.MonthlyAmount = MappedData.net;
    }else{
        salaryparamin.MonthlyAmount = MappedData.brut;
    }

    salaryparamin.ContractType = MappedData.cd_type_contrat;

    //Assurance groupe
    salaryparamin.CollectiveInsuranceAmount = MappedData.assurance_groupe;
    salaryparamin.CollectiveInsuranceEmployeurIntervAmount = MappedData.assurance_groupe_empl;

    salaryparamin.UserName = MappedData.nom;
    salaryparamin.HiringType = MappedData.Scenario_1er_Engage;

    //salaryparamin.OnssSubmitted ? MappedData.cd_soumis_onss=1 : MappedData.cd_soumis_onss=0;
    salaryparamin.OnssSubmitted = MappedData.cd_soumis_onss==1?true:false;

    salaryparamin.JointCommittee = MappedData.commission_paritaire;

    salaryparamin.OnssPrefix = MappedData.prefixe_onss;

    salaryparamin.SecondaryActivity = MappedData.Activite_Sportive_Secondaire;

    //salaryparamin.OnssPrefix = MappedData.prefixe_onss;
    salaryparamin.NumberEmployees = MappedData.cd_effectif_employeur.toString();
    salaryparamin.ProfDeductionSubmitted = MappedData.cd_soumis_precompte.toString();

    if(MappedData.cd_temps_plein == 2){
        salaryparamin.PartTime = true;
        salaryparamin.MondaySchedule = MappedData.regime_horaire[0].toString();
        salaryparamin.TuesdaySchedule = MappedData.regime_horaire[1].toString();
        salaryparamin.WednesdaySchedule = MappedData.regime_horaire[2].toString();
        salaryparamin.ThursdaySchedule = MappedData.regime_horaire[3].toString();
        salaryparamin.FridaySchedule = MappedData.regime_horaire[4].toString();
        salaryparamin.SaturdaySchedule = MappedData.regime_horaire[5].toString();
        salaryparamin.SundaySchedule = MappedData.regime_horaire[6].toString();

        salaryparamin.MondayScheduleRef = MappedData.regime_horaire_emp[0].toString();
        salaryparamin.TuesdayScheduleRef = MappedData.regime_horaire_emp[1].toString();
        salaryparamin.WednesdayScheduleRef = MappedData.regime_horaire_emp[2].toString();
        salaryparamin.ThursdayScheduleRef = MappedData.regime_horaire_emp[3].toString();
        salaryparamin.FridayScheduleRef = MappedData.regime_horaire_emp[4].toString();
        salaryparamin.SaturdayScheduleRef = MappedData.regime_horaire_emp[5].toString();
        salaryparamin.SundayScheduleRef = MappedData.regime_horaire_emp[6].toString();

    }else{
        // let tabHoraire=[456,456,456,456,456,0,0];
        //     MappedData.regime_horaire=tabHoraire;
        //     MappedData.regime_horaire_emp=tabHoraire;
        
        salaryparamin.PartTime = false;
    }

    salaryparamin.ProfDeductionAmount = MappedData.Montant_Imposable_Pp_Ordinaire;
    salaryparamin.GrossSubmittedAmount = MappedData.Montant_Brut_Soumis_Pp;

    salaryparamin.NetBenefitAmount = MappedData.avantages_nature;
    salaryparamin.NetCarBenefitAmount = MappedData.avantages_nature_voiture;
    salaryparamin.HasWorkHomeBenefit = !(MappedData.Sans_Avantage_Domicile_Travail);

    salaryparamin.CollectiveInsuranceAmount = MappedData.mt_cot_trav_assurance_groupe;
    salaryparamin.OtherNegativeAmount = MappedData.divers_net_neg;
    salaryparamin.OtherPositiveAmount = MappedData.divers_net_pos;

    salaryparamin.CollectiveInsuranceEmployeurIntervAmount = MappedData.mt_cot_empl_assurance_groupe;

    salaryparamin.Commissions = MappedData.commissions;

    salaryparamin.EndYearBonusAmount = MappedData.prime_fin_annee;
    salaryparamin.EndYearBonusAmountForemNotSubmitted = MappedData.Prime_Fin_Annee_Forem_Non_Soumise;
    salaryparamin.EndYearBonusAmountForemSubmitted = MappedData.Prime_Fin_Annee_Forem_Soumise;

    salaryparamin.NonReccurentDirectorAmount = MappedData.remuneration_non_periodique;
    salaryparamin.MonthlyCopyrightAmount = MappedData.Droits_Auteur;

    //--------------------------------------------------------------------------------
    // exercice courant
    salaryparamin.CurrentDoubleBonusAmount = MappedData.pecule_vacances;
    salaryparamin.CurrentAdditionalBonusAmount = MappedData.complement_pecule_vacances;

    // exercice précédent
    salaryparamin.PreviousBonusAmount = MappedData.simple_pecule;
    salaryparamin.PreviousDoubleBonusAmount = MappedData.double_pecule;
    salaryparamin.PreviousAdditionalBonusAmount = MappedData.complement_pecule;

    // exercice anticipé
    salaryparamin.AdvanceBonusAmount = MappedData.simple_pecule_anticipe;
    salaryparamin.AdvanceDoubleBonusAmount = MappedData.double_pecule_anticipe;
    salaryparamin.AdvanceAdditionalBonusAmount = MappedData.complement_pecule_anticipe;

    salaryparamin.PublicTransportationAmount = MappedData.abonnement_social;
    salaryparamin.PrivateTransportationAmount = MappedData.frais_deplacement;


    return salaryparamin;
}


    

export default MapService;

